module.exports = __webpack_public_path__ + "img/xx.prt.44ab0812.jpg";